function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Image, Descriptions, Divider, Table, Tag, Space, Button } from "antd";
import { WalletFill } from "react-bootstrap-icons";
import Common from "../../components/includes/Common";
import Moment from "react-moment";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var OrganizationManagement = function OrganizationManagement(_ref) {
  var organization = _ref.organization;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isDataLoading = _useState2[0],
    setIsDataLoading = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    eventsData = _useState4[0],
    setEventsData = _useState4[1];
  var cols = [{
    title: "Evenement",
    dataIndex: "event",
    key: "event",
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: text
      });
    }
  }, {
    title: "Date",
    dataIndex: "date",
    key: "date",
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: /*#__PURE__*/_jsx(Moment, {
          date: text,
          format: "DD/MM/YYYY"
        })
      });
    }
  }, {
    title: "N.Tickets",
    dataIndex: "ticket_amount",
    key: "ticket_amount",
    render: function render(text) {
      return /*#__PURE__*/_jsx(Tag, {
        color: "volcano",
        children: /*#__PURE__*/_jsx("b", {
          children: text.toLocaleString("Fr")
        })
      });
    }
  }, {
    title: "Action",
    dataIndex: "action",
    key: "action",
    render: function render(event) {
      return /*#__PURE__*/_jsxs(Space, {
        children: [/*#__PURE__*/_jsx(Button, {
          type: "link",
          onClick: null,
          children: /*#__PURE__*/_jsx("b", {
            children: "DETAILS"
          })
        }), /*#__PURE__*/_jsx(Button, {
          type: "link",
          onClick: null,
          children: /*#__PURE__*/_jsx("b", {
            children: "PAIEMENT"
          })
        })]
      });
    }
  }];
  useEffect(function () {
    setIsDataLoading(true);
    axios.get("".concat(Common.baseApiUrl, "getorganizationevents/").concat(organization.id, "/").concat(Common.adminUser.id)).then(function (response) {
      if (response.data.status == 200) {
        setEventsData([]);
        response.data.eventsData.forEach(function (e) {
          setEventsData(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              key: e.id,
              event: e.event_label,
              date: e.event_starts_at,
              ticket_amount: e.ticket_amount,
              action: e
            }]);
          });
        });
      }
    })["catch"](function (error) {})["finally"](function () {
      setIsDataLoading(false);
    });
  }, []);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs(Container, {
      children: [/*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 3,
          md: 3,
          sm: 3,
          xs: 4,
          children: /*#__PURE__*/_jsx(Image, {
            src: organization.logo,
            width: "90px",
            height: "90px",
            style: {
              borderRadius: "90px"
            }
          })
        }), /*#__PURE__*/_jsxs(Col, {
          lg: 9,
          md: 9,
          sm: 9,
          xs: 8,
          children: [/*#__PURE__*/_jsxs(Descriptions, {
            title: /*#__PURE__*/_jsx("b", {
              children: "DETAILS STRUCTURE"
            }),
            column: 2,
            children: [/*#__PURE__*/_jsx(Descriptions.Item, {
              label: /*#__PURE__*/_jsx("b", {
                children: "Label"
              }),
              children: organization.label
            }), /*#__PURE__*/_jsx(Descriptions.Item, {
              label: /*#__PURE__*/_jsx("b", {
                children: "Adresse"
              }),
              children: organization.address
            }), /*#__PURE__*/_jsx(Descriptions.Item, {
              label: /*#__PURE__*/_jsx("b", {
                children: "Mobile"
              }),
              children: organization.mobile
            }), /*#__PURE__*/_jsx(Descriptions.Item, {
              label: /*#__PURE__*/_jsx("b", {
                children: "E-mail"
              }),
              children: organization.email
            })]
          }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("h4", {
            children: /*#__PURE__*/_jsxs("b", {
              children: [/*#__PURE__*/_jsx(WalletFill, {
                size: 25
              }), " SOLDE : ", organization.balance.toLocaleString("Fr"), " GNF"]
            })
          })]
        })]
      }), /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsxs(Col, {
          children: [/*#__PURE__*/_jsx(Divider, {
            children: "Ev\xE8nements"
          }), /*#__PURE__*/_jsx(Table, {
            columns: cols,
            dataSource: eventsData,
            pagination: true,
            bordered: true,
            loading: isDataLoading
          })]
        })
      })]
    })
  });
};
export default OrganizationManagement;